<label class="sr-only" [for]="inputId">
    <span>Captcha</span>
    <input
        class="absolute right-[999999px] bottom-[999999px]"
        [id]="inputId"
        (input)="value.set('input triggered')"
        name="name"
        type="text"
        aria-hidden="true"
        tabindex="-1"
    />
</label>
